<template>
  <UserSchedulePanelSessionDialog
    v-if="cancellationSession"
    :panel-session="cancellationSession"
    v-model:open="dialogOpen"
  />
</template>
<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useLoadingStore } from '@/stores/LoadingStore'
import { usePanelSessionStore } from '@/stores/PanelSessionStore'
import UserSchedulePanelSessionDialog from './UserSchedulePanelSessionDialog.vue'

const route = useRoute()
const router = useRouter()
const loadingStore = useLoadingStore()
const panelSessionStore = usePanelSessionStore()

const cancellationTarget = route.query.cancelSession ?? null
const dialogOpen = ref(false)

const cancellationSession = computed(() => {
  if (!cancellationTarget) return null
  return (
    panelSessionStore.loadedScheduledPanelSessions.find(
      (s) => s.id === Number(cancellationTarget)
    ) ?? null
  )
})

watch(
  () => loadingStore.isLoadingCalendar,
  (isLoading) => {
    if (!isLoading && cancellationSession.value) {
      dialogOpen.value = true
    }
  },
  { once: true }
)

watch(dialogOpen, (isOpen, wasOpen) => {
  if (!wasOpen || isOpen) return

  const query = { ...route.query }
  delete query.cancelSession
  router.replace({ query })
})
</script>
